import { selectCopyright, selectFeedbackEnabled } from '@/app/state/app-state/app-state.selectors';
import { State } from '@state/model';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-bottom-info',
    template: `
        <div class="content-column">
            <div class="copyright">
                <ng-container *ngIf="copyright$ | async">{{ copyright$ | async }}</ng-container>
                <egov-text-ui-placeholder *ngIf="(copyright$ | async) === undefined || (copyright$ | async) === null">
                    Copyright © 2020 Tax Collector · All Rights Reserved.
                </egov-text-ui-placeholder>
            </div>
            <app-feedback-button *ngIf="(feedbackEnabled$ | async) !== false" [placeholder]="(feedbackEnabled$ | async) !== true"></app-feedback-button>
        </div>
    `,
    styleUrls: ['./bottom-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomInfoComponent
{
    constructor
    (
        // Dependencies

        private readonly store: Store<State>,
    )
    {}


    // Info

    protected readonly feedbackEnabled$ = this.store.select(selectFeedbackEnabled);
    protected readonly copyright$ = this.store.select(selectCopyright);
}
